import { Skeleton } from "@material-ui/lab";
import React, { useState } from "react";
import AudioIcon from "../AudioIcon";
import { DataGridCustomPagination, dateFormatter } from "../helpers";

import { DataGrid } from "@mui/x-data-grid";

import { Button, CircularProgress, IconButton, Tooltip } from "@mui/material";
import PrintIcon from "@material-ui/icons/Print";
import { useUserData } from "components/customHooks/userDataContext";
import DictationSummary from "components/UI/DictationSummary";

import { getDictationDetails } from "apiHandler/actions";
import { Box } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { getFormattedDate, getFormattedDateNoTz } from "utils/helper";
import { NoteAdd } from "@mui/icons-material";
import PreCharting from "components/modals/preCharting";

const ListTable = ({
  records,
  currentPlaying,
  setCurrentPlaying,
  status,
  assignToMe,
  loading,
  checkboxSelection,
  handleSelectedDictationIds,
}) => {
  const userData = useUserData();
  const [printPage, setPrintPage] = useState(null);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [openPreChart, setOpenPreChart] = useState(false);

  const [row, setRow] = useState(null);
  const navigate = useNavigate();

  const token = userData?.access_token;
  const handlePrintSummary = async (id) => {
    setLoadingPrint(true);
    const payload = {
      type: "Dictation",
      search_criteria: {
        practice_id: userData?.selected_practice,
        dictation_id: id.toString(),
      },
    };
    const dictationDetailResponse = await getDictationDetails(payload, token);
    if (dictationDetailResponse) {
      setPrintPage(
        dictationDetailResponse.map((detail) => ({
          practice_details: detail.practice_details,
          patient_details: detail.patient_details,
          notes: detail.notes,
          dos: detail.dos,
        })),
      );

      window.print();
      setLoadingPrint(false);
      setPrintPage(null);
    } else {
      // setSnackbarMessage("Failed to get Dictation Details");
    }
    setLoadingPrint(false);
    setPrintPage(null);
  };

  const onCLosePreChart = () => {
    setOpenPreChart(false);
  };

  const onOpenPreChart = (row) => {
    setOpenPreChart(true);
    setRow(row);
  };

  const columns = [
    {
      field: "",
      headerName: "Pre-Charting",
      width: 120,
      renderCell: (e) => {
        return (
          <Tooltip
            title={e.row.precharting_id ? "View Pre-Charting" : "Not available"}
          >
            <span>
              <IconButton
                disabled={!e.row.precharting_id}
                onClick={() => onOpenPreChart(e.row)}
              >
                <NoteAdd
                  color={e.row.precharting_id ? "primary" : "disabled"}
                />
              </IconButton>
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "scribe_id",
      headerName: " ",
      width: status === "Total Cases Available" ? 160 : 115,
      sortable: false,
      align: "center",
      filterable: false,
      renderCell: (e) => {
        return e.row.scribe_id === null &&
          status === "Total Cases Available" ? (
          <Box display="flex" alignItems="center">
            <div style={{ marginLeft: "20px" }} className="list-assn-div">
              <button
                className="list-view-btn"
                onClick={() => assignToMe(e.row.id)}
              >
                Assign to me
              </button>
              <Link
                className="list-view-btn"
                to="/scribe-notes-details/data"
                state={e.row}
              >
                view
              </Link>
            </div>
            <IconButton onClick={() => handlePrintSummary(e.id)}>
              {loadingPrint ? (
                <CircularProgress color="secondary" size={15} />
              ) : (
                <PrintIcon color="secondary" />
              )}
            </IconButton>
          </Box>
        ) : (
          <Box display="flex" alignItems="center" justifyContent="center">
            <div className="list-assn-div">
              {status === "Total Cases Available" && "ASSIGNED"}
              <Link
                className="list-view-btn"
                to="/scribe-notes-details/data"
                state={e.row}
              >
                view
              </Link>
            </div>
            <IconButton onClick={() => handlePrintSummary(e.id)}>
              <PrintIcon color="secondary" />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "dos",
      headerName: "Date of service",
      width: 120,
      valueFormatter: (value) => {
        if (!value) {
          return;
        }
        return getFormattedDateNoTz(value);
      },
      valueGetter: dateFormatter,
    },
    {
      field: "first_name",
      headerName: "Patient Name",
      width: 100,
      renderCell: (e) => {
        return (
          <Button
            variant="text"
            onClick={() =>
              navigate(
                `/patients-details/${e.row.first_name}-${e.row.last_name}`,
                { state: e.row },
              )
            }
            className="ml-10"
          >
            {e.row.first_name} {e.row.last_name}
          </Button>
        );
      },
    },
    {
      field: "audio_duration",
      headerName: "Recording",
      width: 150,
      filterable: false,
      renderCell: (e) => {
        return (
          e.value && (
            <div className="list-duration ml-10">
              {e.value}
              <Box ml={2}>
                <AudioIcon
                  showPlayer={true}
                  id={e.row.id}
                  currentPlaying={currentPlaying}
                  setCurrentPlaying={setCurrentPlaying}
                  practice_id={e.row.practice_id}
                  npi={e.row.npi}
                  ext={e.row.file_extension}
                  row={e.row}
                />
              </Box>
            </div>
          )
        );
      },
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      width: 150,
      renderCell: (e) => {
        return <div className="ml-10">{e.row.title}</div>;
      },
    },
    {
      field: "provider_first_name",
      headerName: "Doctor’s / Practice Name",
      minWidth: 150,
      renderCell: (e) => {
        return (
          <div className="ml-10">
            {e.row.provider_first_name} {e.row.provider_last_name}
          </div>
        );
      },
    },
    {
      field: "updated_by",
      headerName: "Last updated By",
      minWidth: 150,
      renderCell: (e) => <div className="ml-10">{e.value}</div>,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      sortable: false,
      renderCell: (e) => {
        return <div className="list-status-row ml-10">{e.value}</div>;
      },
    },
    {
      field: "created_date",
      headerName: "Submitted on",
      width: 120,
      valueFormatter: (value) => {
        if (!value) {
          return;
        }
        return getFormattedDateNoTz(value);
      },
    },
    {
      field: "updated_date",
      headerName: "Last updated",
      width: 120,
      valueFormatter: (value) => {
        if (!value) {
          return;
        }
        return getFormattedDate(value);
      },
      valueGetter: (date) => {
        if (date) return date;
        else return "";
      },
    },
    {
      field: "id",
      headerName: "ID",
      width: 90,
      align: "center",
      renderCell: (e) => <div className="ml-10">{e.value}</div>,
    },
  ];

  if (records === null) {
    return (
      <div>
        <Skeleton variant="text" height={50} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
      </div>
    );
  }
  return (
    <div className="list-datagrid">
      <DataGrid
        loading={loading || false}
        rows={loading ? [] : records}
        columns={columns}
        autoHeight="true"
        disableRowSelectionOnClick
        pagination
        pageSize={20}
        slots={{
          pagination: DataGridCustomPagination,
        }}
        hideFooterPagination={!status}
        hideFooter={!status}
        checkboxSelection={checkboxSelection || false}
        onRowSelectionModelChange={(dictationId) => {
          const strDictationIds = dictationId.map(String);
          // setSelectedRowItems(strDictationIds);
          handleSelectedDictationIds(strDictationIds);
        }}
      />
      {printPage === null ? null : (
        <>
          {printPage.map((params, i) => {
            return <DictationSummary key={i} params={params} />;
          })}
        </>
      )}
      <PreCharting open={openPreChart} onClose={onCLosePreChart} row={row} />
    </div>
  );
};

export default ListTable;
